import React from 'react';

export default () => {
  return (
    <div>
      {/* Home Banner Area */}
      <section class="home_banner_area">
        <div class="banner_inner d-flex align-items-center">
          <div class="container">
            <div class="banner_content row">
              <div class="col-lg-6">
                <h3 class="h3_header">Venda, fature e conquiste novos clientes.</h3>
                <h3 class="h3_header">Mesmo de portas fechadas.</h3>
                <p class="p_header">Ajudamos empreendedores a continuarem expandindo seus negócios em tempos de crise.</p>
                <a class="main_btn" href="https://docs.google.com/forms/d/e/1FAIpQLSc_eyw6UaAcoAK4LdEIsioNvs9iW98IzU91647i1VPGmSHkCg/viewform">
                  Quero ajudar um negócio
                </a>
                <a class="main_btn_outline ml-md-1 mt-1 mt-md-0" href="https://docs.google.com/forms/d/e/1FAIpQLSdKR_XCXhGiL4eol8qrYeThXBoZr84idfdLlAWb8dKGxIJs0A/viewform?usp=sf_link">
                  Quero voltar a vender
                </a>
              </div>
              <div class="col-lg-6">
                <div class="halemet_img">
                  <img src={require('../img/banner/helmat.png')} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Feature Product Area */}
      <section class="feature_product_area">
        <div class="main_box">
				  <div class="container">
					  <div class="feature_product_inner">
					  	<div class="main_title">
					  		<h2>Como te ajudamos?</h2>
					  		<p>Toda crise traz oportunidades. A nossa é de crescer juntos!</p>
					  	</div>

              <div class="row">
                <div class="col-sm-12 col-md-4">
                  <img class="home-image" src={require('../img/home/pic-2.png')} />
                </div>
                <div class="col-sm-12 col-md-8">
                  <p class="home-text">Somos um time de Empreendedorismo e Marketing que decidiu fazer a diferença durante a crise. Como empreendedores, entendemos os riscos que o isolamento traz para as pequenas empresas. Como profissionais de Marketing, temos todas as ferramentas necessárias.</p>

                  <p class="text-center px-5"><strong>Para divulgar e expandir seu negócio, mesmo durante a crise. Todo processo é gratuito e você só paga 5% sobre o que vender</strong></p>

                  <div class="d-flex justify-content-center">
                    <a class="green_btn ml-1" href="https://docs.google.com/forms/d/e/1FAIpQLSdKR_XCXhGiL4eol8qrYeThXBoZr84idfdLlAWb8dKGxIJs0A/viewform?usp=sf_link">
                      Quero voltar a vender
                    </a>
                  </div>
                </div>
              </div>              
					  </div>
				  </div>
        </div>
      </section>

      <section class="clients_logo_area">
      	<div class="container">
          <div class="d-flex">
            <img width="100%" src={require('../img/home/features.png')} />
          </div>
      		<div class="main_title mt-5 pt-5">
      			<h2>Marcas parceiras</h2>
      		</div>
      		<div>
      			<div class="d-flex justify-content-center align-items-center mb-5">
      				<img width="160px" src={require('../img/clients-logo/prepi.png')} alt="" />
      			</div>
      		</div>
      	</div>
      </section>
    </div>
  );
};
